import { Box, Stack } from '@mui/material'
import { preview } from '@/components/form/preview'

import { CheckIn } from './components/CheckIn'
import { CheckOut } from './components/CheckOut'
import { Status } from './components/Status'
import { DetectedCheckIn } from './components/DetectedCheckIn'
import { DetectedCheckOut } from './components/DetectedCheckOut'
import { ServiceTime } from './components/serviceTime'
import { Loads } from './components/Loads'
import { CustomFields } from './components/CustomFields'
import { Note } from './components/Note'
import { Pictures } from './components/Pictures'
import { Signature } from './components/Signature'
import { VoiceMemo } from './components/VoiceMemo'
import { Barcodes } from './components/barcodes'

import { usePreviewExecutionEventMarkers } from './usePreviewExecutionEventMarkers'
import { useTexts } from './useTexts'
interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
  isOpenedInOrderPreviewModal?: boolean
}

export function OrderExecutionView(props: Props) {
  const { extOrder, isOpenedInOrderPreviewModal } = props
  const texts = useTexts()

  usePreviewExecutionEventMarkers(extOrder, !isOpenedInOrderPreviewModal)

  const pods = extOrder.orderStep.trackingData?.pods
  const hasPictures = pods?.pictures && Object.keys(pods.pictures).length > 0
  const hasSignature = pods?.signatures
  const hasVoiceMemo = pods?.audios && Object.keys(pods.audios).length > 0
  const hasAnyPod = hasPictures || hasSignature || hasVoiceMemo
  const showPodsSection = pods || hasAnyPod

  return (
    <>
      <preview.Section spacing={3}>
        <preview.SectionTitle>{texts.reportedDetails.label}</preview.SectionTitle>
        <Stack direction="row" spacing={1}>
          <Box sx={{ flex: 1 }}>
            <CheckIn extOrder={extOrder} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <CheckOut extOrder={extOrder} />
          </Box>
        </Stack>
        <Status extOrder={extOrder} />
      </preview.Section>
      <preview.Divider />

      <preview.Section spacing={3}>
        <preview.SectionTitle>{texts.detectedDetails.label}</preview.SectionTitle>
        <Stack direction="row" spacing={1}>
          <Box sx={{ flex: 1 }}>
            <DetectedCheckIn extOrder={extOrder} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <DetectedCheckOut extOrder={extOrder} />
          </Box>
        </Stack>
        <ServiceTime extOrder={extOrder} />
      </preview.Section>
      <preview.Divider />

      {extOrder.order.loads && Object.keys(extOrder.order.loads).length > 0 && (
        <preview.Section spacing={3}>
          <preview.SectionTitle>{texts.loads.label}</preview.SectionTitle>
          <Loads extOrder={extOrder} />
        </preview.Section>
      )}
      {extOrder.orderStep.customFields &&
        Object.keys(extOrder.orderStep.customFields).length > 0 && (
          <preview.Section spacing={3}>
            <preview.SectionTitle>{texts.customFields.label}</preview.SectionTitle>
            <CustomFields extOrder={extOrder} />
          </preview.Section>
        )}
      {((extOrder.order.loads && Object.keys(extOrder.order.loads).length > 0) ||
        (extOrder.orderStep.customFields &&
          Object.keys(extOrder.orderStep.customFields).length > 0)) && <preview.Divider />}

      {showPodsSection && (
        <>
          <preview.Section spacing={3}>
            <preview.SectionTitle>{texts.PODs.label}</preview.SectionTitle>
            <Note extOrder={extOrder} />
            {hasPictures && <Pictures extOrder={extOrder} />}
            {hasSignature && <Signature extOrder={extOrder} />}
            {hasVoiceMemo && <VoiceMemo extOrder={extOrder} />}
          </preview.Section>
          <preview.Divider />
        </>
      )}

      <preview.Section spacing={3}>
        <preview.SectionTitle>{texts.barcodes.label}</preview.SectionTitle>
        <Barcodes extOrder={extOrder} />
      </preview.Section>
      <preview.Divider />
    </>
  )
}
